export default Object.freeze({
  WORDS: 'words',
  PHRASE: 'phrase'
})
